import { type ReactNode, useMemo } from "react";

import type { CommonDialogProps } from "../../types/dialogs.d.ts";
import { HeaderDivider } from "../HeaderBar/HeaderDivider.tsx";
import { TriggerButton } from "../TriggerButton/TriggerButton.tsx";

/**
 * Add a "Close" HeaderButton after the Dialog actions.
 * Do not expose outside, internal use only.
 */
export const useDialogHeaderActionsWithClose = (props: CommonDialogProps): ReactNode[] | null => {
  return useMemo(() => {
    if (props.title || props.actions?.length) {
      const actions = props.actions ?? [];

      if (typeof props.closeFn === "function") {
        actions?.push(
          <HeaderDivider key={"dialog-escape-divider"} />,
          <TriggerButton
            label={"Close"}
            shortcut={"Escape"}
            icon={"close"}
            onPress={props.closeFn}
            key={"dialog-escape-button"}
          />,
        );
      }

      return actions;
    }

    return null;
  }, [props.title, props.actions, props.closeFn]);
};
